import FormioApi from '@/api/formioApi'
const formioApi = new FormioApi()

export default {
  methods: {
    /**
     * Отправка кастомных событий формио, версии больше 0
     * @param {*} eventModel
     * @returns
     */
    $_callCustomEvent(eventModel) {
      return new Promise((resolve, reject) => {
        formioApi.callCustomEvent(eventModel)
          .then(res => resolve(res))
          .catch(() => reject())
      })
    },
    /**
     * Отправка данных формио, версии больше 0
     * @param {*} eventModel
     * @returns
     */
    $_formSubmission(eventModel) {
      return new Promise((resolve, reject) => {
        formioApi.formSubmission(eventModel)
          .then(res => resolve(res))
          .catch(() => reject())
      })

    },
    /**
     * Формирование свойств формио, для версии больше 0
     * @param {*} formProps
     * @returns
     */
    async $_setFormProps(formProps) {
      const components = formProps.components ? this.fixDefaultValue(JSON.parse(formProps.components)) : []
      return {
        components,
        display: formProps.display,
        isSystem: formProps.isSystem,
        properties: JSON.parse(formProps.properties),
        settings: JSON.parse(formProps.settings),
        submission: {
          data: JSON.parse(formProps.submission) ?? {}
        },
        success: formProps.success,
        errorMessage: formProps.errorMessage,
        unformio: formProps.unformio,

      }
    },
    /**
     * Получение данных формио версии больше 0
     * @param {*} formParams
     * @returns
     */
    async $_getNewForm(formParams) {
      formParams.contactId = formParams.contactId ?? this.$store.getters['GET_USER'].tenderSettings.contactId
      return await formioApi.getForm(formParams)
        .then(async res => {
          return await this.$_setFormProps(res)
        })
        .catch((params) => {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: params,
            showClose: true,
            progress: true,
          })
          return {
            components: []
          }
        })
    },
    fixDefaultValue(items) {
      const checkDefaultValue = (item) => {
        if (!item || typeof item !== 'string') {
          return item
        }
        try {
          const result = JSON.parse(item)
          if (item || typeof item === 'number') { // когда в эллементе значение число, то должно все равно передаватся строкой. А JSON.parse возвращает число
            return '' + result
          }
          return result
        } catch {
          return item
        }
      }

      items.forEach((component) => {
        component.defaultValue = checkDefaultValue(component.defaultValue)
        if (component.components) {
          component.components = this.fixDefaultValue(component.components)
        }
      })
      return items
    },
    async $_getForm(formParams) {
      return await this.$store.dispatch('getForm', formParams)
        .then(async res => {
          const result = {
            components: res ? this.fixDefaultValue(JSON.parse(res)) : []
          }
          return result
        })
        .catch((params) => {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: params,
            showClose: true,
            progress: true,
          })
          return {
            components: []
          }
        })
    },
  }
}
